

















import {Component, Vue} from 'vue-property-decorator';
import PerformanceList from '@/components/PerformanceList.vue';
import {mapFields} from 'vuex-map-fields';
import PullRefresh from '@/components/functional/PullRefresh.vue';
import ApiHandler from '@/logic/ApiHandler';
import ApiRoutes from '@/logic/ApiRoutes';

@Component({
    components: {
        PerformanceList,
        PullRefresh
    },
    computed: mapFields('settings', [
        'host'
    ])
})
export default class Home extends Vue {

    private mounted() {
        // this.testPin(62295);
    }

    // Test the entered pin code
    private async testPin(pin: number) {

        const response = await ApiHandler.request(ApiRoutes.getLoginRequest(pin), true);

        if (response.length > 0) {
            const data = JSON.parse(response);
            this.$store.dispatch('settings/setHost', data);
        }
    }
}
